import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';

export const SettingsPanel = ({ settings, setSettings, onSave }) => {
  if (!settings) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Sistem Parametrləri</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Şirkət Adı</Label>
            <Input
              value={settings.company_name || ''}
              onChange={(e) => setSettings({ ...settings, company_name: e.target.value })}
            />
          </div>
          <div>
            <Label>Texnik başına max ticket</Label>
            <Input
              type="number"
              value={settings.max_tickets_per_technician || 10}
              onChange={(e) => setSettings({ ...settings, max_tickets_per_technician: parseInt(e.target.value) })}
            />
          </div>
          <div>
            <Label>Xəbərdarlıq müddəti (saat)</Label>
            <Input
              type="number"
              value={settings.ticket_warning_hours || 24}
              onChange={(e) => setSettings({ ...settings, ticket_warning_hours: parseInt(e.target.value) })}
            />
          </div>
          <div>
            <Label>Kritik müddət (saat)</Label>
            <Input
              type="number"
              value={settings.ticket_critical_hours || 72}
              onChange={(e) => setSettings({ ...settings, ticket_critical_hours: parseInt(e.target.value) })}
            />
          </div>
        </div>
        
        <div className="flex gap-4">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={settings.auto_assign_enabled}
              onChange={(e) => setSettings({ ...settings, auto_assign_enabled: e.target.checked })}
              className="rounded"
            />
            Avtomatik təyinat aktiv
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={settings.notification_enabled}
              onChange={(e) => setSettings({ ...settings, notification_enabled: e.target.checked })}
              className="rounded"
            />
            Bildirişlər aktiv
          </label>
        </div>
        
        <Button onClick={onSave} className="bg-purple-600 hover:bg-purple-700">
          Yadda Saxla
        </Button>
      </CardContent>
    </Card>
  );
};

export default SettingsPanel;
